import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full 2xl:w-2/3"
}
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "text-xl font-bold text-gray-900 px-1 mb-4" }
const _hoisted_5 = { class: "py-1 float-right inline-flex items-center px-2 border border-transparent text-sm font-bold rounded-lg text-yellow-700 hover:bg-yellow-300 hover:text-yellow-900" }
const _hoisted_6 = { class: "hidden sm:block" }
const _hoisted_7 = { class: "flex h-full flex-col settingsCard gap-6 px-1" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "md:text-lg font-medium text-gray-900" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2 h-px border-0 bg-gray-300 dark:bg-gray-700" }, null, -1)
const _hoisted_12 = { class: "mt-4 grid gap-6 sm:grid-cols-2" }
const _hoisted_13 = { class: "my-6" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "md:text-lg font-medium text-gray-900" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2 h-px border-0 bg-gray-300 dark:bg-gray-700" }, null, -1)
const _hoisted_17 = { class: "py-2" }
const _hoisted_18 = { class: "sm:flex sm:items-center py-2 pb-6" }
const _hoisted_19 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_20 = { class: "flex items-center mt-2 md:mt-0 md:ml-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "mx-3 w-3" }, "-", -1)
const _hoisted_22 = {
  key: 0,
  class: "block pl-4 pt-3 text-red"
}
const _hoisted_23 = { class: "my-6" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "md:text-lg font-medium capitalize text-gray-900" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2 h-px border-0 bg-gray-300 dark:bg-gray-700" }, null, -1)
const _hoisted_27 = { class: "text-sm font-medium text-gray-700 space-y-6 sm:flex sm:items-center sm:space-x-4 sm:space-y-0" }
const _hoisted_28 = ["checked"]
const _hoisted_29 = { class: "ml-3 block leading-6 text-gray-700" }
const _hoisted_30 = ["checked"]
const _hoisted_31 = { class: "ml-3 block leading-6 text-gray-700" }
const _hoisted_32 = { class: "mt-6 mb-1 text-sm font-semibold text-gray-900" }
const _hoisted_33 = { class: "relative mt-2 flex items-start" }
const _hoisted_34 = { class: "flex h-5 items-center" }
const _hoisted_35 = { class: "ml-3 text-sm" }
const _hoisted_36 = {
  for: "set-process-duration",
  class: "font-medium text-gray-700"
}
const _hoisted_37 = { class: "relative mt-3 flex items-start" }
const _hoisted_38 = { class: "flex h-5 items-center" }
const _hoisted_39 = { class: "ml-3 text-sm" }
const _hoisted_40 = { for: "time-preview-enabled" }
const _hoisted_41 = { class: "font-medium text-gray-700" }
const _hoisted_42 = ["disabled"]

import { ArrowRightIcon } from "@heroicons/vue/24/solid";
import { useCurrentCustomerName, useCurrentSiteId } from "@oculai/planner";
import { ref, watch } from "vue";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { onBeforeRouteUpdate } from "vue-router";
import LoadingSpinner from "@/components/loading_state/LoadingSpinner.vue";
import SectionDragAndDrop from "@/components/other/SectionDragAndDrop.vue";
import InfoTooltip from "@/components/tooltips/TooltipInfo.vue";
import { useSaveBeforeLeaveConfirmationModal } from "@/composables/toast";
import DailyReportRepository from "@/repositories/DailyReportRepository";
import logger from "@/services/logger";
import { ReportSettings } from "@/types/DailyReport";
import RulesTable from "@/views/settings_project/components/RulesTable.vue";
import WeatherRules from "@/views/settings_project/components/WeatherRules.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabDailyReport',
  setup(__props) {

const { t } = useI18n();

const showSaveBeforeLeaveConfirmationModal = useSaveBeforeLeaveConfirmationModal();
const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();

const activeTab = ref<keyof ReportSettings["weather"]>("cold_temperature");
const validationErrorsWeather = ref<string[]>([]);
const settings = ref({} as ReportSettings);
const initialSettings = ref({} as ReportSettings);
const isSettingsLoading = ref(false);
const hasChange = ref(false);

onMounted(async () => {
  await getSettings();
  isSettingsLoading.value = true;
});

watch(
  settings,
  async (newSettings, oldSettings) => {
    if (Object.keys(oldSettings).length !== 0) {
      hasChange.value = true;
    }
  },
  { deep: true },
);

onBeforeRouteUpdate((to, from, next) => {
  if (!hasChange.value) {
    return next();
  }
  showSaveBeforeLeaveConfirmationModal().then((confirmed) => {
    if (confirmed) {
      next();
    }
  });
});

const addWeatherRule = (idenftifier: string) => {
  if (idenftifier == "precipitation") {
    const item = {
      time_period: "WEATHER_TIME_RANGE",
      duration_operator: ">=",
      duration_value: 3,
      volume_operator: ">=",
      volume_value: 3,
      volume_unit: "mm/h",
    };
    settings.value.weather[`${idenftifier}`].push(item);
  }
  if (idenftifier == "cold_temperature") {
    const item = {
      min_operator: "<=",
      min_value: -4.0,
      max_operator: "<=",
      max_value: -0.0,
    };
    settings.value.weather[`${idenftifier}`].push(item);
  }
  if (idenftifier == "hot_temperature") {
    const item = {
      min_operator: ">=",
      min_value: 25,
      max_operator: ">=",
      max_value: 32.5,
    };
    settings.value.weather[`${idenftifier}`].push(item);
  }
};

const resetFixedRule = (index: number, operator: string) => {
  if (operator == "24/7-7") {
    settings.value.weather.precipitation[index].duration_value = null;
    settings.value.weather.precipitation[index].duration_operator = "ENTIRE_TIME_PERIOD";
    settings.value.weather.precipitation[index].volume_unit = "mm";
    settings.value.weather.precipitation[index].volume_value = 20.0;
  }
  if (operator == "ENTIRE_TIME_PERIOD") {
    settings.value.weather.precipitation[index].duration_value = null;
  }
};

const onUpdateSections = (sections: ReportSettings["sections"]) => {
  settings.value.sections = sections;
  hasChange.value = true;
};

const removeWeatherRule = (index: number) => {
  if (index > -1) {
    (settings.value.weather[activeTab.value] as []).splice(index, 1);
  }
};

const saveConfig = () => {
  validationErrorsWeather.value = validateWeatherSettings() || [];

  if (validationErrorsWeather.value.length) {
    return;
  }

  if (JSON.stringify(settings.value) !== JSON.stringify(initialSettings.value)) {
    saveSettings(settings.value);
  }
  hasChange.value = false;
};

const getSettings = () => {
  return DailyReportRepository.getDailyReportSettings(currentCustomerName, currentSiteId)
    .then((response) => {
      const config = {
        weather: response.data.weather,
        site_duration: response.data.site_duration,
        sections: response.data.sections,
      };

      settings.value = config;
      initialSettings.value = structuredClone(config);
    })
    .catch((error) => {
      logger.error(error);
    });
};

const saveSettings = (payload: ReportSettings) => {
  return DailyReportRepository.updateDailyReportSettings(
    currentCustomerName,
    currentSiteId,
    payload,
  )
    .then(() => {
      initialSettings.value = structuredClone(settings.value);
    })
    .catch((error) => {
      logger.error(error);
    });
};

const validateWeatherSettings = () => {
  const validationErrors = [];

  if (settings.value.weather.time_range.start_time >= settings.value.weather.time_range.end_time) {
    validationErrors.push("time_range");
  }
  for (let i = 0; i < settings.value.weather.cold_temperature.length; i++) {
    if (settings.value.weather.cold_temperature[i]["max_value"] === undefined) {
      validationErrors.push("cold_temperature");
      break;
    }
  }
  for (let i = 0; i < settings.value.weather.hot_temperature.length; i++) {
    if (settings.value.weather.hot_temperature[i]["max_value"] === undefined) {
      validationErrors.push("hot_temperature");
      break;
    }
  }
  for (let i = 0; i < settings.value.weather.precipitation.length; i++) {
    if (settings.value.weather.precipitation[i]["volume_value"] === undefined) {
      validationErrors.push("precipitation");
      break;
    } else {
      if (settings.value.weather.precipitation[i]["volume_value"] <= 0) {
        validationErrors.push("precipitation");
        break;
      }
    }
    if (settings.value.weather.precipitation[i]["duration_operator"] === ">=") {
      if (settings.value.weather.precipitation[i]["duration_value"] === undefined) {
        validationErrors.push("precipitation");
        break;
      } else {
        if ((settings.value.weather.precipitation[i]["duration_value"] || 0) < 1) {
          validationErrors.push("precipitation");
          break;
        }
      }
    }
  }
  if (!settings.value.weather.wind.max_value) {
    validationErrors.push("wind");
  } else {
    if (settings.value.weather.wind.max_value < 0) {
      validationErrors.push("wind");
    }
  }

  return validationErrors;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!isSettingsLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingSpinner)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("report.config")), 1),
          _createVNode(_component_router_link, {
            to: {
          name: 'DailyReportOverview',
          params: {
            customer_name: _ctx.$route.params.customer_name,
            site_id: _ctx.$route.params.site_id,
          },
        }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("report.overview_link")), 1),
                _createVNode(_unref(ArrowRightIcon), {
                  class: "ml-2 h-4 w-4",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, _toDisplayString(_unref(t)("report.config_sections")), 1),
                _createVNode(InfoTooltip, { class: "ml-1" }, {
                  text: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)("report.sections_tooltip")), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(SectionDragAndDrop, {
                  onOnUpdate: onUpdateSections,
                  sectionsList: settings.value.sections
                }, null, 8, ["sectionsList"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h3", _hoisted_15, _toDisplayString(_unref(t)("report.weather_threshold")), 1),
                _createVNode(InfoTooltip, { class: "ml-1" }, {
                  text: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)("report.weather_warnings_tooltip")), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)("report.weather.time_range")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "time",
                      id: "dayStart",
                      name: "dayStart",
                      class: "oai-inputs my-0.5 block",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((settings.value.weather.time_range.start_time) = $event))
                    }, null, 512), [
                      [_vModelText, settings.value.weather.time_range.start_time]
                    ]),
                    _hoisted_21,
                    _withDirectives(_createElementVNode("input", {
                      type: "time",
                      id: "dayEnd",
                      name: "dayEnd",
                      class: "oai-inputs my-0.5 block",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settings.value.weather.time_range.end_time) = $event))
                    }, null, 512), [
                      [_vModelText, settings.value.weather.time_range.end_time]
                    ]),
                    (
                    validationErrorsWeather.value.includes('time_range') &&
                    settings.value.weather.time_range.start_time >= settings.value.weather.time_range.end_time
                  )
                      ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_unref(t)("err.time")), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(WeatherRules, {
                  onTabChanged: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = $event)),
                  validationErrors: validationErrorsWeather.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(RulesTable, {
                      activeTab: activeTab.value,
                      rules: settings.value.weather[activeTab.value],
                      validationError: validationErrorsWeather.value.length > 0,
                      onDeleteEntry: removeWeatherRule,
                      onAddEntry: addWeatherRule,
                      onResetFixedRule: resetFixedRule
                    }, null, 8, ["activeTab", "rules", "validationError"])
                  ]),
                  _: 1
                }, 8, ["validationErrors"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h3", _hoisted_25, _toDisplayString(_unref(t)("report.section_title.working_hours")), 1),
                _createVNode(InfoTooltip, { class: "ml-1" }, {
                  text: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)("report.working_hours_tooltip")), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_26
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", {
                class: "cursor-pointer flex items-center",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (settings.value.site_duration.oai_tracking = true))
              }, [
                _createElementVNode("input", {
                  id: "oai-tracking-true",
                  type: "radio",
                  checked: settings.value.site_duration.oai_tracking,
                  class: "h-4 w-4 border-gray-300 text-yellow-600 focus:ring-yellow-600"
                }, null, 8, _hoisted_28),
                _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)("report.tracking_label_enabled")), 1)
              ]),
              _createElementVNode("div", {
                class: "cursor-pointer flex items-center",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (settings.value.site_duration.oai_tracking = false))
              }, [
                _createElementVNode("input", {
                  id: "oai-tracking-true",
                  type: "radio",
                  checked: !settings.value.site_duration.oai_tracking,
                  class: "h-4 w-4 border-gray-300 text-yellow-600 focus:ring-yellow-600"
                }, null, 8, _hoisted_30),
                _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)("report.tracking_label_disabled")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)("report.section_title.processes")), 1),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  id: "set-process-duration",
                  "aria-describedby": "working_hours",
                  name: "working_hours",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((settings.value.site_duration.set_process_duration) = $event)),
                  class: "h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500"
                }, null, 512), [
                  [_vModelCheckbox, settings.value.site_duration.set_process_duration]
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(t)("report.process_time_label")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  id: "time-preview-enabled",
                  "aria-describedby": "toggle_time_visibility",
                  name: "toggle_time_visibility",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((settings.value.site_duration.time_preview_enabled) = $event)),
                  class: "h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500"
                }, null, 512), [
                  [_vModelCheckbox, settings.value.site_duration.time_preview_enabled]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, [
                  _createElementVNode("p", _hoisted_41, _toDisplayString(_unref(t)("report.general.enable_time_visibility")), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "mt-4 flex items-center gap-2 rounded-md self-end w-min bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600 disabled:bg-gray-300 disabled:cursor-default",
            onClick: saveConfig,
            disabled: !hasChange.value
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("buttons.save")), 1)
          ], 8, _hoisted_42)
        ])
      ]))
}
}

})